import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class EditionTmpHomeView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    // Posters
    const offsetY = window.innerHeight
    const poster1 = container.querySelector(".poster-1")
    if (poster1) {
      TweenMax.from(poster1, .4, {y: offsetY, ease: Power3.easeOut, delay: .2})
    }
    const poster2 = container.querySelector(".poster-2")
    if (poster2) {
      TweenMax.from(poster2, .4, {y: -offsetY, ease: Power3.easeOut, delay: .2})
    }
    // Footer
    const footer = container.querySelector(".editionhome-footer")
    if (footer) {
      TweenMax.from(footer, .4, {y: 20, opacity: 0, ease: Power3.easeOut, delay: .4})
    }

  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    // Footer
    const footer = container.querySelector(".editionhome-footer")
    if (footer) {
      TweenMax.to(footer, .4, {y: 20, opacity: 0, ease: Back.easeIn, delay: 0})
    }
    // Posters
    const offsetY = window.innerHeight
    const poster1 = container.querySelector(".poster-1")
    if (poster1) {
      TweenMax.to(poster1, .4, {y: offsetY, ease: Power3.easeIn, delay: .2})
    }
    const poster2 = container.querySelector(".poster-2")
    if (poster2) {
      TweenMax.to(poster2, .4, {y: -offsetY, ease: Power3.easeIn, delay: .2})
    }
    
  }

}

export default EditionTmpHomeView